<div class="flex max-h-full min-h-0 w-full flex-col">
  <!-- header -->
  <div class="flex items-start gap-3 px-6 pb-2 pt-6">
    <mat-icon class="text-amber-500 mt-1" fontSet="material-icons-outlined">warning</mat-icon>
    <div>
      <h2 class="text-xl font-bold">{{ 'DOCUMENT_GENERATE.OFFICE_CHANGE_MODAL.TITLE' | t }}</h2>
      <p class="text-secondary mt-1 text-base leading-relaxed"
        [innerHTML]="'DOCUMENT_GENERATE.OFFICE_CHANGE_MODAL.MESSAGE' | t: { officeName: data.officeName }"></p>
    </div>
  </div>

  <!-- cuerpo -->
  <div class="min-h-0 flex-1 overflow-auto px-6 py-4">
    @if (data.affectedItems.length) {
    <p class="text-base font-semibold">
      {{ 'DOCUMENT_GENERATE.OFFICE_CHANGE_MODAL.ITEMS_TO_REMOVE' | t: { count: data.affectedItems.length, total: data.totalItems } }}
    </p>
    <p class="text-secondary mb-3 mt-1 text-base leading-relaxed">
      {{ 'DOCUMENT_GENERATE.OFFICE_CHANGE_MODAL.AFFECTED_NOTE' | t }}
    </p>
    <div class="overflow-x-auto rounded-xl border">
      <table class="w-full min-w-[420px] border-collapse text-base">
        <thead class="sticky top-0 bg-gray-50 dark:bg-gray-800">
          <tr class="text-secondary text-left">
            <th class="px-4 py-2 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.PRODUCT' | t }}</th>
            <th class="px-4 py-2 text-center font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.QUANTITY' | t }}</th>
          </tr>
        </thead>
        <tbody>
          @for (item of data.affectedItems; track item.lineId) {
          <tr class="border-t">
            <td class="px-4 py-2">
              <div class="flex flex-col">
                <span class="text-secondary text-xs font-semibold">{{ item.code }}</span>
                <span class="uppercase">{{ item.name }}</span>
              </div>
            </td>
            <td class="px-4 py-2 text-center">{{ item.quantity }}</td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    } @else {
    <p class="text-secondary text-base leading-relaxed">
      {{ 'DOCUMENT_GENERATE.OFFICE_CHANGE_MODAL.NO_ITEMS_REMOVED' | t }}
    </p>
    }
  </div>

  <!-- footer -->
  <div class="flex justify-end gap-3 border-t bg-gray-50 px-6 py-4 dark:bg-transparent">
    <button mat-stroked-button type="button" (click)="cancel()">{{ 'GENERAL.CANCEL' | t }}</button>
    <button mat-flat-button color="primary" type="button" (click)="confirm()">{{ 'DOCUMENT_GENERATE.OFFICE_CHANGE_MODAL.CONFIRM' | t }}</button>
  </div>
</div>
